<template>
    <div class="header_box">
        <div class="cont_list flex">
            <p class="logo" @click="$router.go(-1)"><img src="@/assets/m/logo.png" alt=""></p>
            <div class="right_btn_cont">
                    
                <div class="userInfo flex" v-if="userInfo">
                    <!-- <p class="img"><img :src="userInfo.avatar" alt=""></p> -->
                    <p class="user_name">{{userInfo.nickname}}</p>
                    <p class="logout" @click="logout">退出</p>
                </div>
                <div class="btn_cont flex" v-else>
                    <p class="btn2" @click="loginBtn()">登录</p>
                    <!-- <p class="btn2">注册</p> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "header_box",
  data() {
    return {
        userInfo:''
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
  methods: {
    ...mapMutations(['ShowMLoginModal', 'ShowTipModal', 'ClearUserInfo']), //登录弹窗

    loginBtn(url){
       this.ShowMLoginModal()
    },
    logout(){
         this.$axios.post(`/user/logout`, {}, {useLog: true}).then(res=>{
            if(res.code==1){
                localStorage.clear();
                sessionStorage.clear();
                location.reload()
            }else{
                this.$message.error(res.msg)
            }
        })
        // this.$confirm('确定退出账号?', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {
           
        // })
    }
  },
};
</script>
<style scoped lang="scss">
.header_box{
    background: #fff;
    height: 68px;
    overflow: hidden;
    position: relative;
    z-index: 9;
    // box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
    .cont_list{
        height: 100%;
        margin: 0 13px;
        justify-content: space-between;
        p.logo{
           width: 234px;
            height: 28px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .menu_list{
            flex: 1;
            margin-left: 78px;
            justify-content: flex-end;
            li{
                margin-right: 27px;
                height: 68px;
                line-height: 68px;
                position: relative;
                a{
                    display: block;
                     padding: 0 21px;
                     font-size: 16px;
                    color: #333333;
                }
            }
            .activeMenu{
                color: #0057B5;
                // border-left: 1px solid #F0F0F0;
                // border-right: 1px solid #F0F0F0;
            }
        }
        .right_btn_cont{
            .btn_cont{
                p{
                    width: 76px;
                    height: 32px;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
                p.btn2{
                   background: rgba(0,87,181,0.1);
                    color: #0057B5;
                    border-radius: 4px;
                }
            }

            .userInfo{
               p.img{
                width: 30px;
                height: 30px;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 100%;
                }
               }
               p.user_name{
                font-size: 14px;margin-left: 7px;
                color: #333333;
               }
               .logout{
                margin-left: 10px;
                cursor: pointer;
               }
            }
        }
    }
}
</style>
